import React from 'react';
import { IField, ISubmission } from '../../constants/types';
import survey from '../../components/investigation/survey';
import { EnhancedTable } from '../../components/general/EnhancedTable';
import { dateAndTimeFromPostgresString, fullDateFromPostgresString, researcherFullName } from '../../utils';
import { useDepartments } from '../../hooks';
import Loader from '../../components/Loader';
import { renderValue } from './SurveyRecordsTable.renderValue';

interface SurveyRecordsTableProps {
    fields: IField[];
    submissions: ISubmission[];
    locale:string,
    onSelectSubmission: (index:number) => void;
}

const SurveyRecordsTable: React.FC<SurveyRecordsTableProps> = ({ fields, locale, submissions, onSelectSubmission }) => {
    const { researchers, loadingDepartments } = useDepartments();
    let headCells = fields.sort((fieldA, fieldB) => fieldA.order - fieldB.order > 0 ? 1 : -1).map((field) => ({
        id: field.name,
        alignment: "left",
        label: field.label
    }));
    
    // SHER-210 — extracted to './SurveyRecordsTable.renderValue' so its BMI
    // bypass + safe object default are independently unit-testable. The original
    // inline switch returned the raw `{bmi, bmi_height, bmi_weight}` object on
    // its default branch, crashing the /patient/.../nurse page with React #31
    // ("Objects are not valid as a React child") whenever a nursing submission
    // contained a BMI field.
    if(loadingDepartments){
        return <Loader />
    } 

    const rows = submissions.map((submission, index) => {
        const researcher = researchers.find((researcher) => researcher.uuid === submission.uuidResearcher);
        let record = {id:index, date : dateAndTimeFromPostgresString(locale, submission.updatedAt), 
                    staff : researcher ? researcherFullName(researcher) : "Unknown"};
        
        for(let i = 0; i < headCells.length; i++){
            const valueField = headCells[i].id;
            const field = submission.surveyRecords.find((record) => record.surveyField.name === valueField);
            const value = renderValue(field?.value, field?.surveyField.type || "text");
            record[headCells[i].id] = value;
        }

        return record;
    });
    
    //prepend staff to headcells
    headCells.unshift({id:"staff", alignment:"left", label:"Staff"});

    
    headCells.unshift({id:"date", alignment:"left", label:"Date"});
    return (
        <EnhancedTable noHeader noSelectable headCells={headCells} rows={rows} 
            selectRow={(index:number) => onSelectSubmission(index)} />
    );
};

export default SurveyRecordsTable;
